<template>
    <div class="index">
        <div class="view">
            <router-view v-if="isRouterAlive"></router-view>
        </div>
        <Navigation />
    </div>
</template>

<script>
import Navigation from '@/components/navigation';
export default {
    components: {
        Navigation
    },
    provide (){
        return {
            reload:this.reload
        }
    },
    data (){
        return {
            isRouterAlive: true
        }
    },
    mounted(){
        // this.isRouterAlive = false
        // this.$nextTick(() => {
        //     setTimeout(()=> {
        //         //处理IOS黑条
        //         this.isRouterAlive = true
        //     },2000)
        // });
    },
    methods :{
        reload(){
            // this.isRouterAlive = false
            // this.$nextTick(() => {
            //     //处理IOS黑条
            //     this.isRouterAlive = true
            // });
        },
    }
};
</script>

<style lang="scss" scoped>
.index {
    position: relative;
    height: 100%;

    .view {
        position: absolute;
        bottom: 50px;
        top: 0;
        width: 100%;
    }
}
</style>